import { useState } from "react";
import { dadosLogin } from "../../zustand/zuztand";
import { Link } from "react-router-dom";
import "../calendario_geral/calendario_geral.css"
import Calendario from "../../components/calendario/calendario.jsx";

function CalendarioGeral(props) {
  const [userLogado, setUserLogado] = useState("");
  const { changeIfLogado, ifLogado } = dadosLogin()
  return <>

    <div className="d-flex container-fundo-geral">
      <div className="d-flex container-body-geral align-items-center55">
        <div className=" col-12 border calendario-geral">
          <Calendario tipo="geral" className="" />
        </div>
        <div>
          <button type="button" className="btn btn-primary mt-1 buton-geral-listar d-flex d-none" data-bs-toggle="modal" data-bs-target="#ModalLista">Listar</button>
        </div>
      </div>
    </div>
  </>
}
export default CalendarioGeral;